import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { api, ApiError } from "@/shared/api";
import { s } from "@/shared/strings";
import { Button } from "@/shared/components/ui/button";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/shared/components/ui/card";
import { Logo } from "@/shared/components/Logo";

export function Register() {
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.register(email, name, password);
      nav("/host");
    } catch (ex) {
      setErr(ex instanceof ApiError ? ex.message : "Erro inesperado.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="bg-bg flex min-h-dvh flex-col items-center justify-center px-6 py-10">
      <div className="w-full max-w-sm">
        <Link to="/" className="mb-8 flex justify-center">
          <Logo />
        </Link>
        <Card>
          <CardHeader>
            <CardTitle>{s.createAccount}</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <Label htmlFor="name">{s.name}</Label>
                <Input
                  id="name"
                  required
                  autoComplete="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-2">
                <Label htmlFor="email">{s.email}</Label>
                <Input
                  id="email"
                  type="email"
                  required
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-2">
                <Label htmlFor="password">{s.password} (mín. 8)</Label>
                <Input
                  id="password"
                  type="password"
                  required
                  minLength={8}
                  autoComplete="new-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              {err && <p className="text-14 text-bad font-semibold">{err}</p>}
              <Button type="submit" disabled={busy} className="w-full">
                {s.createAccount}
              </Button>
            </form>
          </CardContent>
        </Card>
        <p className="text-14 text-chalk-3 mt-6 text-center">
          Já tem conta?{" "}
          <Link to="/entrar" className="text-amber-fg font-semibold hover:underline">
            {s.login}
          </Link>
        </p>
      </div>
    </main>
  );
}
